import gql from 'graphql-tag';

export default gql`
  mutation removeRecipeFromBox($input: RemoveRecipeFromBoxInput!) {
    removeRecipeFromBox(input: $input) {
      status
    }
  }
`;
